<template>
  <transition name="el-loading-fade" @after-leave="handleAfterLeave">
    <div
      v-show="visible"
      class="loading-mask"
      :class="[customClass, { 'is-fullscreen': fullscreen }]">
      <div class="loading-spinner">
        <svg class="circular" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" :r="radius" fill="none"/>
        </svg>
        <p v-if="text" class="loading-text">{{ text }}</p>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
  	name: 'Loading',
    data() {
      return {
        text: null,
        fullscreen: true,
        visible: false,
        customClass: '',
        radius:20
      };
    },

    methods: {
      handleAfterLeave() {
        this.$emit('after-leave');
      }
    }
  };
</script>

<style scoped>
.loading-mask{
    position: absolute;
    z-index: 10000;
    background-color: rgba(0, 0, 0, 0.3);
    margin: 0;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transition: opacity 0.3s;
}

.loading-spinner{
    top: 50%;
    margin-top:-21px;
    width: 100%;
    text-align: center;
    position: absolute;
}

.circular {
      width: 42px;
      height: 42px;
      animation: loading-rotate 2s linear infinite;
    }
.path{
    animation: loading-dash 1.5s ease-in-out infinite;
    stroke-dasharray: 90,150;
    stroke-dashoffset: 0;
    stroke-width: 2;
    stroke: #fff;
    stroke-linecap: round;
}

.loading-text {
  color: #fff;
  margin: 3px 0;
  font-size: 14px;
}

@keyframes loading-rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes loading-dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -40px;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -120px;
  }
}
</style>



// WEBPACK FOOTER //
// Loading.vue?325f867e